import { render, staticRenderFns } from "./Chanpin.vue?vue&type=template&id=fd758710&scoped=true&"
import script from "./Chanpin.vue?vue&type=script&lang=js&"
export * from "./Chanpin.vue?vue&type=script&lang=js&"
import style0 from "./Chanpin.vue?vue&type=style&index=0&id=fd758710&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd758710",
  null
  
)

export default component.exports